import ConfirmationModal from 'components/Common/ConfirmationModal';
import TableContainer from 'components/Common/TableContainer';
import TableSkeleton from 'components/Common/TableSkeleton';
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, UncontrolledTooltip } from 'reactstrap';
import { deleteQuote, deleteQuoteReset, getAllQuotes } from 'store/actions';

const RecentQuotes = () => {
    const history = useHistory()
    const getRole = JSON.parse(localStorage.getItem("authUser"));
    const dispatch = useDispatch()
    const quotes = useSelector(state => ({
        quotes: state.GetQuotes.quotes.quote
    }), shallowEqual)

    const deleteQuotes = useSelector(state => ({
        deleteQuotes: state.DeleteQuote
    }))

    const [data, setData] = useState(quotes)

    useEffect(() => {
        if (quotes !== undefined) {
            setData(quotes)
        }
    }, [data, quotes])
    const [deleteModal, setDeleteModal] = useState(false)
    const [quoteId, setquoteId] = useState(null)
    const handleDelete = (id) => {
        setquoteId(id)
        setDeleteModal(true)
    }

    const [reload, setReload] = useState(0)
    useEffect(() => {
        dispatch(getAllQuotes())
        setReload(0)
    }, [reload])

    const columns = React.useMemo(
        () => [
            {
                Header: () => null,
                id: "expandRow",
                Cell: ({ row }) => (
                    <span {...row.getToggleRowExpandedProps()}>
                        {row.isExpanded ? <i className="bx bx bx-chevron-up" /> : <i className="bx bx bx-chevron-down" />}
                    </span>
                )
            },
            {
                accessor: 'quoteNumber',
                Header: 'Reference #',
            },
            {
                accessor: 'shipmentBy',
                Header: 'Shipment by',
            },
            {
                accessor: 'shipmentType',
                Header: 'Shipment type',
            },
            {
                accessor: 'portOfLoading',
                Header: 'Port of loading',
            },
            {
                accessor: 'postOfDischarge',
                Header: 'Port of discharge',
            },
            {
                id: 'clientCode',
                accessor: 'clientDetail.clientCode',
                Header: 'Client code',
            },
            {
                id: 'clientName',
                accessor: 'clientDetail.name',
                Header: 'Client name',
            },
            {
                id: 'status',
                accessor: 'quoteStatus',
                Header: 'Quote status',
                Cell: ({ row }) => {
                    return <div className='action-filed'><span className={`text-uppercase status ${row.original.quoteStatus? row.original.quoteStatus:"none"}`}>{row.original.quoteStatus}</span></div>
                }
            },
            {
                id: 'si-status',
                accessor: 'siStatusData.shipperStatus',
                Header: 'SI status',
                Cell: ({ row }) => {
                    return <div className='action-filed'><span className={`text-uppercase status ${row.original?.siStatusData?.shipperStatus?row.original?.siStatusData?.shipperStatus:"none"}`}>{row.original?.siStatusData?.shipperStatus || 'n/a'}</span></div>
                }
            },
            {
                id: "shipper",
                accessor: "_id",
                Header: "SI form",
                Cell: ({ row }) => (
                    <div className="d-flex gap-3 justify-content-center">
                        {
                            (row.original.quoteStatus === 'request si' || row.original.quoteStatus === 'completed') ?
                                (row.original?.siStatusData?.shipperStatus === 'review' || row.original?.siStatusData?.shipperStatus === 'completed' || row.original?.siStatusData?.shipperStatus === 'submitted') ?
                                    <button type="button" className="btn-sm btn-secondary btn btn-draft" onClick={() => navigateViewShipper(row.original?.siStatusData)}>view</button> :
                                    ((row.original?.siStatusData?.shipperStatus === 'draft' || row.original?.siStatusData?.shipperStatus === 're-submit')) ?
                                        ((row.original.quoteStatus === 'request si') && (getRole?.user?.role === 'CLIENT')) ?
                                            <button type="button" className="btn-sm btn-secondary btn btn-draft" onClick={() => navigateUpdateShipper(row.original)}>update</button> :
                                            <button type="button" className="btn-sm btn-secondary btn btn-draft" onClick={() => navigateViewShipper(row.original?.siStatusData)}>view</button> :
                                        ((row.original.quoteStatus === 'request si') && (getRole?.user?.role === 'CLIENT')) ?
                                            <button type="button" className="btn-sm btn-secondary btn btn-draft" onClick={() => navigateAddShipper(row.original._id)}>Add</button> :
                                            <span className='text-uppercase'>n/a</span> :
                                <span className='text-uppercase'>n/a</span>
                        }
                    </div>
                )
            },
            {
                accessor: 'userDetail.firstName',
                Header: 'Added by',
            },
            {
                id: '_id',
                accessor: "_id",
                Header: "Actions",
                Cell: ({ row }) => (
                    <div className="d-flex gap-3 justify-content-center action-btn">
                        <Link
                            to={`/enquiries/update-quote/${row.original._id}`}
                            className={`text-success ${row?.original?.quoteStatus === 'draft' ? "" : ""}`}>
                            <i className="bx bx-edit-alt font-size-18" id="edittooltip" />
                            <UncontrolledTooltip placement="top" target="edittooltip">
                                Click to edit
                            </UncontrolledTooltip>
                        </Link>
                        <Link
                            to={`/enquiries/${row.original._id}`}
                            className="text-secondary">
                            <i className="mdi mdi-eye font-size-18" id="view" />
                            <UncontrolledTooltip placement="top" target="view">
                                Click to view
                            </UncontrolledTooltip>
                        </Link>
                        <Link to={`#`} id={"delete"}
                            onClick={() => handleDelete(row.original._id)}
                        >
                            <i className="bx bx-trash text-danger font-size-17" />
                            <UncontrolledTooltip placement="top" target={"delete"}>
                                Click to delete
                            </UncontrolledTooltip>
                        </Link>
                    </div>
                )
            },
            {
                id: 'action',
                accessor: "_id",
                Header: "Actions",
                Cell: ({ row }) => (
                    <div className="d-flex gap-3 justify-content-center">
                        <Link
                            to={`/enquiries/${row.original._id}`}
                            className="text-secondary">
                            <i className="mdi mdi-eye font-size-18 primary-color" id="view" />
                            <UncontrolledTooltip placement="top" target="view">
                                Click to view
                            </UncontrolledTooltip>
                        </Link>
                    </div>
                )
            },
            {
                accessor: ' ',
                Header: ' ',
            },
        ],
        []
    )

    const expandedRows = React.useMemo(() => {
        if (data?.quotes) {
            let arr;
            let d = data?.quotes;
            if (d?.length > 0) {
                arr = d?.map((sid, ind) => {
                    return { [ind]: true };
                });
            }
            return arr;
        }
    }, []);

    const subTable = (row) => {
        return row?.original?.container?.length > 0 ? (
            <div className='collapse-row sub-table'>
                <div className='collapse-heading'>
                    {
                        (row?.original?.shipmentBy === 'SEA') &&
                        <>
                            <h5>Container Type</h5>
                            <h5>Container Size</h5>
                            {((row?.original?.cargoType === 'GENERAL') || (row?.original?.cargoType === 'DG')) ?
                                <>
                                    <h5>Quantity</h5>
                                    <h5>Length</h5>
                                    <h5>Width</h5>
                                    <h5>Height</h5>
                                    {/* <h5>Weight</h5> */}
                                </> :
                                (row?.original?.cargoType === 'ODC') ?
                                    <>
                                        <h5>Length</h5>
                                        <h5>Width</h5>
                                        <h5>Height</h5>
                                        {/* <h5>Weight</h5> */}
                                    </> :
                                    <>
                                        <h5>Temparature</h5>
                                        <h5>Humidity</h5>
                                        <h5>Ventilation</h5>
                                    </>
                            }
                            <h5>Gross weight</h5>
                        </>
                    }
                    {
                        (row?.original?.shipmentBy === 'AIR') &&
                        <>
                            <h5>Package type</h5>
                            <h5>Length</h5>
                            <h5>Width</h5>
                            <h5>Height</h5>
                            <h5>Weight</h5>
                            <h5>Quantity</h5>
                            {/* <h5>Weight Per-cargo</h5> */}
                        </>
                    }
                </div>
                {
                    (row?.original?.shipmentBy === 'SEA') &&
                        ((row?.original?.cargoType === 'GENERAL') || (row?.original?.cargoType === 'DG')) ?
                        row?.original?.container.map((list) => (
                            <div key={list._id} className='collapse-data'>
                                <p>{list.containerType}</p>
                                <p>{list.containerSize}</p>
                                <p>{list.noOfContainer ? list.noOfContainer : '-'}</p>
                                <p>{list.length ? list.length : '-'}</p>
                                <p>{list.width ? list.width : '-'}</p>
                                <p>{list.height ? list.height : '-'}</p>
                                {/* <p>{list.weight ? list.weight : '-'}</p> */}
                                <p>{list.weightPerCargo}</p>
                            </div>
                        )) :
                        (row?.original?.cargoType === 'ODC') ?
                            row?.original?.container.map((list) => (
                                <div key={list._id} className='collapse-data'>
                                    <p>{list.containerType}</p>
                                    <p>{list.containerSize}</p>
                                    <p>{list.length}</p>
                                    <p>{list.width}</p>
                                    <p>{list.height}</p>
                                    <p>{list.noOfContainer}</p>
                                    <p>{list.weightPerCargo}</p>
                                </div>
                            )) : (row?.original?.cargoType === 'REEFER') &&
                            row?.original?.container.map((list) => (
                                <div key={list._id} className='collapse-data'>
                                    <p>{list.containerType}</p>
                                    <p>{list.containerSize}</p>
                                    <p>{list.temperature}</p>
                                    <p>{list.humidity}</p>
                                    <p>{list.ventilation}</p>
                                    <p>{list.weightPerCargo}</p>
                                </div>
                            ))
                }
                {
                    (row?.original?.shipmentBy === 'AIR') &&
                    row?.original?.container.map((list) => (
                        <div key={list._id} className='collapse-data'>
                            <p>{list.packageType}</p>
                            <p>{list.length}</p>
                            <p>{list.width}</p>
                            <p>{list.height}</p>
                            <p>{list.weight}</p>
                            <p>{list.noOfContainer}</p>
                            {/* <p>{list.weightPerCargo}</p> */}
                        </div>
                    ))
                }
            </div >
        ) : "No Data"
    }

    const requestQuote = () => {
        history.push("/enquiries/enquiry-request");
    }
    useEffect(() => {
        if (deleteQuotes?.deleteQuotes?.success?.staus === "SUCCESS" ||
            deleteQuotes?.deleteQuotes.error !== '') {
            setDeleteModal(false);
            dispatch(deleteQuoteReset(''))
        }
    }, [deleteQuotes])

    const navigateAddShipper = (quoteId) => {
        history.push(`/enquiries/add-shipper-information/${quoteId}`);
    }
    const navigateUpdateShipper = (quoteData) => {
        history.push(`/enquiries/update-shipper-information/${quoteData?._id}/${quoteData?.siStatusData?.shipperId}`);
    }
    const navigateViewShipper = (siStatusData) => {
        if (siStatusData?.shipperType === 'AIR')
            history.push(`/enquiries/air-shipper-information-details/${siStatusData?.shipperId}`);
        else if (siStatusData?.shipperType === 'SEA')
            history.push(`/enquiries/sea-shipper-information-details/${siStatusData?.shipperId}`);
    }
    
    return (
        <Card className="recent-quotes">
            <CardBody className='accordion-style'>
                <h4 className="card-title">Recent Enquiries</h4>    
                {!data?.quotes ? <TableSkeleton datacount={8} listcount={5} /> : <> {data?.quotes.length !== 0 ? <><TableContainer
                    columns={columns}
                    data={data?.quotes ? data?.quotes : []}
                    isGlobalFilter={false} // set true for global filter enable
                    isAddOptions={false} // set true for button enable
                    customPageSize={5}
                    handleOrderClicks={requestQuote}
                    iSPageOptions={false} // set true for pagination options
                    hiddenValue={getRole?.user?.role === 'CLIENT' ? ['clientCode', 'clientName', 'action'] : ['_id']}
                    className="custom-header-css recent-quotes-table"
                    btnname="Recent Enquiries"
                    renderRowSubComponent={subTable}
                    expandRows
                    expandedRowObj={expandedRows}
                />
                    <div className='action-btn'>
                        <button className="float-end secountry-btn" onClick={() => history.push("/enquiries")}>View all</button>
                    </div></> : <h6 className='my-3 mx-auto text-center'>No recent enquiries available</h6>}</>}
                {/* Delete modal */}
                <ConfirmationModal
                    okButton={() => {
                        const data = {}
                        if (quoteId) data["quoteId"] = quoteId
                        dispatch(deleteQuote(data))
                        setReload(1)
                    }}
                    cancelButton={() => {
                        setDeleteModal(false);
                    }}
                    title="Delete Enquiry"
                    icon={alert}
                    loader={deleteQuotes.deleteQuotes.loading}
                    status={"error"}
                    butttonName={"Delete"}
                    setStatusModal={setDeleteModal}
                    statusModal={deleteModal}
                    content={<p>Are you sure, do you want to delete this enquiry</p>}
                />
            </CardBody>
        </Card>
    )
};

export default RecentQuotes;